import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import React from "react";

const Input = (props) => {
  const { label, name, hasError, showPassword, setShowPassword, ...rest } =  props;

  return (
    <div className={hasError ? "form-group has-error" : "form-group"}>
      <span className="input-focus"></span>
      <label htmlFor={name}>{label}</label>
      <div className="input password-field">
        <Field className="form-control " id={name} name={name} {...rest} />
        {name.toLowerCase().includes("password") && (
          <div className="pass-icon formik-icon">
            {" "}
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              color="gray"
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
